import { DocumentPayloadMap } from 'bff'
import { DocumentVariant } from 'piramid-constants'
import { ComponentType } from 'react'
import OrderReportDefault from './default'

type OrderReportProps = DocumentPayloadMap['order_report']

/**
 * Layouts del documento por tenant. Agregar uno es sumar una entrada acá y su
 * valor a `documentVariants` (piramid-constants); nada más cambia — ni el
 * contrato, ni el resolver, ni el frontend.
 */
const OrderReportVariants: Partial<
  Record<DocumentVariant, ComponentType<OrderReportProps>>
> = {
  default: OrderReportDefault,
}

/**
 * Una variante declarada sin componente cae a `default` en vez de romper la
 * generación: un documento con el layout equivocado es preferible a un PDF que
 * no sale.
 */
const OrderReport = (props: OrderReportProps) => {
  const Variant = OrderReportVariants[props.meta.variant] ?? OrderReportDefault

  return <Variant {...props} />
}

export default OrderReport
